import { render } from "./nav_footer.vue?vue&type=template&id=a546a0e4"
import script from "./nav_footer.vue?vue&type=script&lang=js"
export * from "./nav_footer.vue?vue&type=script&lang=js"

import "./nav_footer.vue?vue&type=style&index=0&id=a546a0e4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__